const faqItems = [
  {
    q: '91吃瓜是什么平台？',
    a: '91吃瓜是一个综合性娱乐八卦与热点资讯导航平台，聚合91吃瓜网、91吃瓜在线、91吃瓜官网等入口，为吃瓜群众提供最新娱乐动态、明星八卦、影视综艺资讯及社会热点事件的一站式浏览体验。',
  },
  {
    q: '如何找到91吃瓜最新网址？',
    a: '本站作为91吃瓜官方网站入口大全，实时更新最新可用地址，确保您随时通过本站导航快速访问91吃瓜主页、网页版与在线入口，无需担心网址失效问题。',
  },
  {
    q: '91吃瓜网、91吃瓜在线和91吃瓜官网有什么区别？',
    a: '三者均为同一平台的入口方式，91吃瓜网是PC网页版、91吃瓜在线为移动端适配版本、91吃瓜官网为主站入口，内容同步更新，您可根据设备选择最方便的访问方式。',
  },
  {
    q: '平台内容更新时间是什么？',
    a: '91吃瓜平台实行全天候运营，编辑团队7×24小时监控全网热点，重要娱乐事件和劲爆八卦通常在第一时间同步上线，确保您不错过任何新鲜热辣的瓜。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          吃瓜常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于91吃瓜平台访问与使用的常见疑问解答</p>
        <div className="space-y-4">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer px-5 py-4 hover:bg-background-200/50 transition-colors list-none">
                <h3 className="text-base font-semibold text-foreground-900 pr-4">{item.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line text-lg"></i>
                </span>
                <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line text-lg"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}